import React from "react";
import styled from "@emotion/styled";

import Icon from "~/core/scripts/components/Icon";

const Wrapper = styled.figure`
  display: flex;
  margin: 24px 0;
`;

const Candidate = styled.div`
  border-radius: 3px;
  background-color: ${({ background, theme }) =>
    background || theme.colors.grey90};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 3px;
  width: 120px;
  ${(p) =>
    p.won &&
    `box-shadow: 0 0 4px 2px
    ${
      p.democratic
        ? p.theme.colors.democraticReduced
        : p.theme.colors.republicanReduced
    };`}

  ${({ theme }) => theme.breakpoints.sm.down} {
    width: 110px;
  }
`;

const Name = styled.div`
  font-size: 16px;
  text-align: center;
`;

const Head = styled.img`
  width: 40px;
  height: auto;
  margin: 18px 0 12px;

  ${({ theme }) => theme.breakpoints.sm.down} {
    width: 32px;
  }
`;

const Number = styled.span`
  display: block;
  line-height: 1.4;
  font-weight: bold;
  position: relative;
  color: ${({ theme, party }) =>
    party === "democratic" ? theme.colors.democratic : theme.colors.republican};
  font-size: 48px;

  ${({ theme }) => theme.breakpoints.sm.down} {
    font-size: 32px;
  }

  svg {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(120%) translateY(25%);
  }
`;

export default function ResultBoard({
  background,
  trumpOverallVotes = 0,
  bidenOverallVotes = 0,
  trumpWon = false,
  bidenWon = false,
}) {
  return (
    <Wrapper>
      <Candidate background={background} won={bidenWon} democratic>
        <Head src="images/heads/biden.png" width="189" height="252" />
        <Name>Biden</Name>
        <Number party="democratic">
          {bidenOverallVotes}
          <Icon
            type="elected-check"
            style={{
              transition: "opacity 100ms 100ms",
              opacity: bidenWon ? 1 : 0,
            }}
          />
        </Number>
      </Candidate>
      <Candidate background={background} won={trumpWon} republican>
        <Head src="images/heads/trump.png" width="189" height="252" />
        <Name>Trump</Name>
        <Number party="republican">
          {trumpOverallVotes}
          <Icon
            type="elected-check"
            style={{
              transition: "opacity 100ms 100ms",
              opacity: trumpWon ? 1 : 0,
            }}
          />
        </Number>
      </Candidate>
    </Wrapper>
  );
}
